import { render, staticRenderFns } from "./ReportPagination.vue?vue&type=template&id=0ef1cd82"
import script from "./ReportPagination.vue?vue&type=script&lang=js"
export * from "./ReportPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports